const SettingsNavigation = {
	id: 'settings',
	title: 'Settings',
	type: 'collapse',
	icon: 'heroicons-outline:cog',
	url: '/apps/settings',
	children: [
		{
			id: 'settings.account',
			icon: 'heroicons-outline:user-circle',
			title: 'Account',
			type: 'item',
			url: '/settings/account',
			subtitle: 'Manage your public profile and private information'
		},
		{
			id: 'settings.security',
			icon: 'heroicons-outline:lock-closed',
			title: 'Security',
			type: 'item',
			url: '/settings/security',
			subtitle: 'Manage your password and 2-step verification preferences'
		}
	]
};
export default SettingsNavigation;
